import React, { useEffect } from 'react';
import { useSelector } from "react-redux";

const NavigationLanguageSelector = function ({ onInit }) {
    const navigation = useSelector((state) => state.navigation);

    if (!navigation || !navigation.linkToOtherSites.length) {
        return null;
    }

    useEffect(() => {
        if (typeof onInit === 'function') {
            onInit();
        }
    }, []);

    return <ul className="navbar__item--thin-list">
        <li>
            <select
                value={navigation.linkToOtherSites.value}
                className="navbar__language-selector"
                onChange={event => window.location = event.target.value}
            >
                {navigation.linkToOtherSites.map((link, i) =>
                    <option
                        key={`${link.linkText}-${i}`}
                        value={link.linkUrl ? link.linkUrl : ''}
                    >
                        {link.linkText}
                    </option>
                )}
            </select>
        </li>
    </ul>
}

export default NavigationLanguageSelector;
